import { NODE_VISUAL_TOKENS, resolveNodeVisualState } from "../nodes/visualState";
import { useInteractionState } from "../../../flow-kit";
export function useNodeVisualState({ isSelected = false, isContextMenuActive = false, isCurrentStep = false, isOnPath = false, isDimmed = false, isEdit = false, hasPublishError = false, isOrphaned = false, isSkeleton = false }) {
    const { isHovered, isActive, handleMouseEnter, handleMouseLeave } = useInteractionState({
        isSelected,
        isContextMenuActive
    });
    const state = resolveNodeVisualState({
        isActive,
        isHovered,
        isCurrentStep,
        isOnPath,
        isEdit,
        hasPublishError,
        isOrphaned,
        isSkeleton
    });
    // Selection / current / on-path visually promote the step and take
    // precedence over the dashed hint, so dashing only applies when none of
    // those are set.
    const isDashed = Boolean(isEdit && (isSkeleton || isOrphaned) && !isActive && !isCurrentStep && !isOnPath);
    return {
        state,
        tokens: NODE_VISUAL_TOKENS[state],
        isDashed,
        dimClass: isDimmed ? "opacity-30" : "",
        handleMouseEnter,
        handleMouseLeave
    };
}

//# sourceMappingURL=useNodeVisualState.js.map